import * as React from 'react';
import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Badge from './Badge';
import Icon from './Icon';
import Translate, { translate } from './Translate';
import FilterSearch from './FilterSearch';
import FilterValue from './FilterValue';
import { FilterItemProps } from '../models/components/Filter';

const FilterPropertyHeader = styled<any, any>('h4')`
    ${propStyles};
    cursor: pointer;
`;

FilterPropertyHeader.defaultProps = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontFamily: 'heading',
    fontWeight: 'medium',
    color: 'body',
};

const FilterListWrapper = styled<any, any>('div')`
    ${propStyles};
`;

FilterListWrapper.defaultProps = {
    flex: '1 0 auto',
    paddingX: 'md',
    paddingY: 'md',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: ['none none solid none', 'none none solid none', 'none'],
};

const FilterList = styled<any, any>('ol')`
    ${propStyles};
    list-style: none;
    -ms-overflow-style: -ms-autohiding-scrollbar;
`;

FilterList.defaultProps = {
    maxHeight: '300px',
    overflowX: 'hidden',
    overflowY: 'auto',
};

const ClearIndividualFiltersButton = styled<any, any>('button')`
    ${propStyles};
`;

ClearIndividualFiltersButton.defaultProps = {
    display: 'flex',
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'gray500',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'body',
    },
};

const rightAlignStyleProps = {
    order: 1,
};
const leftAlignStyleProps = {
    margin: '0 0 0 auto',
};
const SelectedFilterInfo = styled<any, any>('div')`
    ${propStyles};
`;

SelectedFilterInfo.defaultProps = {
    display: 'flex',
    flex: '1',
};

const Divider = styled<any, any>('hr')`
    ${propStyles};
` as any; // TODO: why?!

Divider.defaultProps = {
    borderWidth: '1px',
    borderColor: 'gray500',
    borderStyle: 'dotted none none none',
};

@inject('translations')
@inject('filterStore')
@observer
class FilterItem extends Component<FilterItemProps> {
    render() {
        const {
            theme,
            translations,
            filterStore,
            filter,

            // withFilter HoC props
            expanded,
            toggleExpanded,
            selectedCount,
            total,
            search,
            clearSearch,
            selectedValues,
            filteredValues,
            filterSearch,
            enableSearch,
        } = this.props;

        return (
            <FilterListWrapper>
                <FilterPropertyHeader
                    onClick={toggleExpanded}
                    {...theme.FilterPropertyHeader}
                >
                    <Icon
                        fileName={
                            expanded
                                ? 'FilterItemHeaderIconExpanded'
                                : 'FilterItemHeaderIcon'
                        }
                        {...theme.FilterItemHeaderIcon}
                    />
                    <Translate>{filter.label}</Translate>
                    {selectedCount > 0 && (
                        <SelectedFilterInfo>
                            {filterStore.clearIndividualFilters.enabled && (
                                <ClearIndividualFiltersButton
                                    {...(filterStore.clearIndividualFilters
                                        .align === 'right'
                                        ? rightAlignStyleProps
                                        : leftAlignStyleProps)}
                                    {...theme.ClearIndividualFiltersButton}
                                    onClick={
                                        filterStore.filtersActive
                                            ? () =>
                                                  filterStore.clearFiltersOfType(
                                                      filter.property,
                                                      filter.filterSearchKey
                                                  )
                                            : () => undefined
                                    }
                                >
                                    <Icon
                                        height="1.4em"
                                        width="1.4em"
                                        margin="0 0 0 0.25em"
                                        fileName="ClearFiltersIcon"
                                        {...theme.ClearFiltersIcon}
                                    />
                                </ClearIndividualFiltersButton>
                            )}
                            <Badge
                                {...filterStore.clearIndividualFilters.align ===
                                    'right' && leftAlignStyleProps}
                                data-selected={selectedCount > 0}
                                selected={{
                                    bgColor: 'primary',
                                }}
                                {...theme.FilterTotalBadge}
                            >
                                {selectedCount}/{total}
                            </Badge>
                        </SelectedFilterInfo>
                    )}
                </FilterPropertyHeader>
                {expanded && (
                    <Fragment>
                        {enableSearch && (
                            <FilterSearch
                                type="text"
                                placeholder={`${translate(
                                    translations,
                                    'Search'
                                )} ${translate(translations, filter.label)}`}
                                value={search}
                                onChange={e => filterSearch(e.target.value)}
                                onClear={clearSearch}
                                showClear={search.length > 0}
                            />
                        )}
                        <FilterList {...theme.SelectedFilterList}>
                            {selectedValues.map((value, valueIndex) => (
                                <FilterValue
                                    key={`${value.label}-${valueIndex}`}
                                    label={value.label}
                                    ui={filter.ui}
                                    value={value.value}
                                    checked={true}
                                    onChange={e =>
                                        filterStore.toggleFilter(
                                            filter.property,
                                            value.value,
                                            filter.filterSearchKey,
                                            true
                                        )
                                    }
                                    active={true}
                                    {...theme.SelectedFilterListItem}
                                />
                            ))}
                        </FilterList>
                        {selectedValues.length > 0 &&
                            filteredValues.length > 0 && (
                                <Divider {...theme.FilterListDivider} />
                            )}
                        <FilterList {...theme.FilterList}>
                            {filteredValues.map((value, valueIndex) => (
                                <FilterValue
                                    key={`${value.label}-${valueIndex}`}
                                    label={value.label}
                                    ui={filter.ui}
                                    value={value.value}
                                    checked={false}
                                    onChange={e =>
                                        filterStore.toggleFilter(
                                            filter.property,
                                            value.value,
                                            filter.filterSearchKey,
                                            false
                                        )
                                    }
                                    active={filterStore.isActive(
                                        filter.property,
                                        value.value
                                    )}
                                    {...theme.FilterListItem}
                                />
                            ))}
                        </FilterList>
                    </Fragment>
                )}
            </FilterListWrapper>
        );
    }
}

export default withTheme(FilterItem);



// WEBPACK FOOTER //
// ./src/Components/FilterItem.tsx